import { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import SummaryApi from '../common'
import service from '../common/HttpService'
import useTranslate from '../hooks/useTranslate'
import Context from '../context'

const BrandList = () => {
    const { translateText, languageCode } = useContext(Context)
    const [loading, setLoading] = useState(false)
    const categoryLoading = new Array(10).fill(null)
    const [brandProduct, setBrandProduct] = useState([])
    const [translatedBrands, setTranslatedBrands] = useState([])

    const fetchBrandProduct = async () => {
        setLoading(true)
        try {
            const response = await service.get(SummaryApi.getBrand.url)
            console.log("All Product response===>", response)
            setBrandProduct(response?.extraData?.brand)
        } catch (error) {
            console.log("Error fetching brands:", error)
            setBrandProduct([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchBrandProduct()
    }, [])

    useEffect(() => {
        const translateBrands = async () => {
            if (!languageCode || languageCode === 'en' || !brandProduct || brandProduct.length === 0) {
                setTranslatedBrands(brandProduct);
                return;
            }

            try {
                const translated = await Promise.all(
                    brandProduct.map(async (brand) => ({
                        ...brand,
                        translatedName: await translateText(brand.name, languageCode)
                    }))
                );
                setTranslatedBrands(translated);
            } catch (error) {
                console.error("Error translating brands:", error);
                setTranslatedBrands(brandProduct);
            }
        };

        translateBrands();
    }, [languageCode, translateText, brandProduct]);

    return (
        <div className='bg-[#f4f7f5] py-10 border-b border-gray-100 w-full overflow-hidden'>
            <div className='container mx-auto px-6 relative'>
                <div className='flex items-center gap-10 pb-4 overflow-x-auto scrollbar-none'>
                    {
                        loading ? (
                            categoryLoading.map((el, index) => {
                                return (
                                    <div className='flex flex-col items-center gap-4 min-w-[120px]' key={"categoryLoading" + index}>
                                        <div className='h-24 w-24 md:w-28 md:h-28 rounded-full bg-slate-100 border-4 border-white shadow-md'></div>
                                        <div className='h-4 w-20 bg-slate-100 rounded'></div>
                                    </div>
                                )
                            })
                        ) :
                            (
                                Array.isArray(translatedBrands) && translatedBrands?.map((product, index) => {
                                    const imageUrl = product?.image || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2sSeQqjaUTuZ3gRgkKjidpaipF_l6s72lBw&s';
                                    return (
                                        <Link
                                            to={"/product-category?brand=" + product?.name + "&brandId=" + product?.id}
                                            className='cursor-pointer flex flex-col items-center gap-2 min-w-[120px] group transition-all duration-300'
                                            key={product?.id + "-" + index}
                                        >
                                            <div className='w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden p-6 bg-white border border-gray-100 shadow-sm flex items-center justify-center group-hover:scale-105 group-hover:shadow-lg transition-all duration-500'>
                                                <img
                                                    src={imageUrl}
                                                    alt={product?.translatedName || product?.name}
                                                    className='h-full w-full object-contain mix-blend-multiply'
                                                    onError={(e) => { e.target.src = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2sSeQqjaUTuZ3gRgkKjidpaipF_l6s72lBw&s' }}
                                                />
                                            </div>
                                            <p className='text-center text-xs md:text-sm font-bold text-gray-500 group-hover:text-[#00b259] transition-colors capitalize'>
                                                {product?.translatedName || product?.name}
                                            </p>
                                        </Link>
                                    )
                                })
                            )
                    }
                </div>
            </div>
        </div>
    )
}

export default BrandList